import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';

export type UrlUploadVideoPayload = z.output<typeof urlUploadVideoPayloadSchema>;
export type UrlUploadVideoPayloadDTO = z.input<typeof urlUploadVideoPayloadSchema>;

export const urlUploadVideoPayloadSchema = z.object({
  /** Kinexon camera UUID from camera calibration / integration mapping. */
  cameraId: z.string(),
  end: isoDatetimeToDate,
  /**
   * Ingest finished flag expected by the video integration service; omit on request defaults to
   * false.
   */
  finished: z.boolean().optional(),
  resource: z.string(),
  start: isoDatetimeToDate,
});

export type UrlUploadVideosPayload = z.output<typeof urlUploadVideosPayloadSchema>;
export type UrlUploadVideosPayloadDTO = z.input<typeof urlUploadVideosPayloadSchema>;

/** The endpoint takes a bare array of videos as its body. */
export const urlUploadVideosPayloadSchema = z.array(urlUploadVideoPayloadSchema);
